import React, { useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import isEmpty from 'lodash/isEmpty';

import messages from 'aurora-translations';
import { ADGMImage } from 'aurora-components';
import AddBrokerModal from './AddBrokerModal';
import BrokerFields from './BrokerModalDetails/BrokerFields';
import BrokerSummary from './BrokerSummary';
import styles from './styles';

function BrokerDetails(props) {
  const {
    classes,
    intl,
    locale,
    broker,
    fetchBrokerDetails = () => {},
    addBroker = () => {},
    deleteBroker = () => {},
    isEditable = false,
  } = props;
  const dispatch = useDispatch();

  const [brokerModalConfig, setBrokerModalConfig] = useState({
    open: false,
    selectedUser: null,
    isEditMode: false,
  });

  const [fetchError, setFetchError] = useState({
    messageShow: false,
    statusCode: null,
  });
  const handleModalOpenBroker = () => {
    setBrokerModalConfig({ open: true, selectedUser: null, isEditMode: false });
  };

  const handleModalClose = () => {
    setBrokerModalConfig({ open: false, selectedUser: null, isEditMode: false });
  };

  const [brokerResponse, setBrokerResponse] = useState(null);

  const handleFetchBroker = id => {
    dispatch(fetchBrokerDetails(id)).then(res => {
      if (res?.broker?.success) {
        setBrokerResponse(res?.broker?.result);
        setFetchError({ messageShow: false, statusCode: null });
      } else {
        setFetchError({ messageShow: true, statusCode: res?.data?.result?.statusCode });
      }
    });
  };
  const handleAddBroker = (formState, brokerKey) => {
    dispatch(addBroker(brokerResponse, brokerKey || 0)).then(() => {
      setBrokerModalConfig({ open: false, selectedUser: null, isEditMode: false });
      setBrokerResponse(null);
    });
  };

  const handleDeleteBroker = userId => {
    dispatch(deleteBroker(userId)).then(() => {
      setBrokerModalConfig({ open: false, selectedUser: null, isEditMode: false });
      setBrokerResponse(null);
    });
  };

  const handleModalEditOpen = brokerId => {
    setBrokerResponse(broker);
    setBrokerModalConfig({ open: true, selectedUser: brokerId, isEditMode: false });
  };
  return (
    <>
      {!isEmpty(broker) && (
        <Paper variant='outlined' className={classes.paperCardFrame}>
          <div className={classes.titleHead}>
            {isEmpty(broker) ? (
              <Typography variant='h6' component='h1' className={classes.title}>
                <FormattedMessage {...messages.broker_details} />
              </Typography>
            ) : (
              <>
                <Typography variant='h6' component='h1' className={classes.title}>
                  <FormattedMessage {...messages.broker} />
                </Typography>
                {isEditable && (
                  <div className={classes.titleHeadActions}>
                    <Button
                      onClick={() => handleModalEditOpen(broker.userId)}
                      startIcon={<ADGMImage name='PencilRed.svg' alt='edit-pencil' />}
                    >
                      <Typography>
                        <FormattedMessage {...messages.Edit} />
                      </Typography>
                    </Button>
                    <span>
                      <ADGMImage name='DividerRed.svg' alt='divider' />
                    </span>
                    <Button
                      onClick={() => handleDeleteBroker(broker.userId)}
                      startIcon={<ADGMImage name='DustbinRed.svg' alt='delete-dustbin' />}
                    >
                      <Typography>
                        <FormattedMessage {...messages.delete} />
                      </Typography>
                    </Button>
                  </div>
                )}
              </>
            )}
          </div>

          <div className={classNames(classes.innerCard)}>
            <div>
              {isEmpty(broker) && isEditable ? (
                <>
                  <Button
                    variant='outlined'
                    className={classes.largeButton}
                    size='large'
                    onClick={handleModalOpenBroker}
                  >
                    <ADGMImage name='plusIconBlack.svg' alt='plus' />
                    <Typography component='p' variant='body1'>
                      <FormattedMessage {...messages.add_broker} />
                    </Typography>
                  </Button>
                  <AddBrokerModal
                    intl={intl}
                    locale={locale}
                    modalConfig={brokerModalConfig}
                    toggleModal={() => setBrokerModalConfig({ ...brokerModalConfig, open: !brokerModalConfig.open })}
                    handleModalClose={handleModalClose}
                    modalTitle={<FormattedMessage {...messages.add_broker} />}
                    userDetailsTitle={<FormattedMessage {...messages.broker_details} />}
                    apiResponse={brokerResponse}
                    handleFetchUser={handleFetchBroker}
                    handleAddUser={handleAddBroker}
                    FieldComponent={BrokerFields}
                    fetchError={fetchError}
                    buttonText={
                      brokerModalConfig.isEditMode ? (
                        <div>
                          <FormattedMessage {...messages.edit_broker} />
                        </div>
                      ) : (
                        <div>
                          <FormattedMessage {...messages.add_broker} />
                        </div>
                      )
                    }
                  />
                </>
              ) : (
                <BrokerSummary classes={classes} lang={locale} broker={broker} />
              )}
            </div>
          </div>
        </Paper>
      )}
    </>
  );
}

BrokerDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  broker: PropTypes.object.isRequired,
  fetchBrokerDetails: PropTypes.func.isRequired,
  addBroker: PropTypes.func.isRequired,
  deleteBroker: PropTypes.func.isRequired,
  isEditable: PropTypes.bool,
};

BrokerDetails.defaultProps = {
  isEditable: false,
};

export default withStyles(styles)(BrokerDetails);
